import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../Icon';
import { Button } from '../Button';
import { logEvent } from '../../../lib/shared/event-logger';
import { EVENT_TYPES } from '../../../lib/shared/event-types';
import { useIntersectionTracking } from '../../shared/use-intersection-tracking';
import shieldImg from '../../assets/images/slide/shield-new-2.png';
import styles from './StartSlideV5.css';

function StartSlideV5({ onContinue, id }) {
    useIntersectionTracking(`#${EVENT_TYPES.QUIZ_START_BUTTON_VIEWED}`);

    const handleStart = label => () => {
        logEvent(EVENT_TYPES.QUIZ_START_CLICKED, { label });
        onContinue();
    };

    return (
        <div className={styles.form} key={id}>
            <h1 className={styles.title}>Check If Your Accounts Are Safe</h1>
            <span className={styles.label}>Your Gmail, Facebook, Bank, and other accounts may be at risk</span>
            <p className={styles.description}>Pass this quiz to personalize your subscription</p>
            <div className={styles.imageWrapper}>
                <button
                    type='button'
                    className={styles.imageButton}
                    onClick={handleStart('image')}
                    aria-label='Check my accounts'
                >
                    <img src={shieldImg} alt='shield' className={styles.image} />
                </button>
            </div>
            <Button
                label='check my accounts'
                onClick={handleStart('all')}
                className={styles.button}
                buttonProps={{ id: EVENT_TYPES.QUIZ_START_BUTTON_VIEWED }}
            />
            <ul className={styles.checkList}>
                <li className={styles.checkItem}>
                    <Icon name='check' />
                    100% confidential
                </li>
                <li className={styles.checkItem}>
                    <Icon name='check' />
                    Takes just a moment
                </li>
                <li className={styles.checkItem}>
                    <Icon name='check' />
                    Covers all your important accounts
                </li>
            </ul>
            <div className={styles.informationCards}>
                <div className={styles.informationCard}>
                    <Icon name='goal' />
                    <div>
                        <p className={styles.informationCardLabel}>24K+ USERS</p>
                        <p className={styles.informationCardValue}>Secured their data with us</p>
                    </div>
                </div>
                <div className={styles.informationCard}>
                    <Icon name='starSecondary' />
                    <div>
                        <p className={styles.informationCardLabel}>83% give 4+ stars</p>
                        <p className={styles.informationCardValue}>Rated by users</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

StartSlideV5.propTypes = {
    onContinue: PropTypes.func.isRequired,
    id: PropTypes.number.isRequired
};

export {
    StartSlideV5
};
